"use client";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { SignedCurrencyInput } from "@/components/ui/signed-currency-input";
export function EarningsInput({
  id,
  value,
  disabled,
  onChange,
  error,
  currency,
}: {
  id: string;
  currency: string;
  value: unknown;
  disabled?: boolean;
  error?: string;
  onChange: (value: string) => void;
}) {
  const [profit, setProfit] = useState("");
  const [pay, setPay] = useState("");
  return (
    <div className="space-y-3">
      <SignedCurrencyInput
        id={id}
        aria-labelledby={`${id}-label`}
        aria-invalid={Boolean(error)}
        currency={currency}
        aria-describedby={error ? `${id}-error` : undefined}
        value={typeof value === "string" && value !== "not sure" ? value : ""}
        onValueChange={onChange}
        disabled={disabled}
        className="h-12 text-base"
        placeholder="For example, 100,000"
      />
      <Button
        type="button"
        variant={value === "not sure" ? "secondary" : "outline"}
        aria-pressed={value === "not sure"}
        className="min-h-11 w-full sm:w-auto"
        disabled={disabled}
        onClick={() => onChange("not sure")}
      >
        I’m not sure yet
      </Button>
      <details className="rounded-lg border">
        <summary className="min-h-12 cursor-pointer rounded-lg px-4 py-3 text-sm font-medium hover:bg-muted/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
          Help me work this out
        </summary>
        <div className="space-y-3 rounded-lg bg-muted/30 p-4">
          <p className="text-sm text-muted-foreground">
            Use the same last 12 months as your sales. Start with the money left
            after business expenses. Add your salary if you counted it as an
            expense. If the business lost money, enter a negative number.
          </p>
          <label htmlFor={`${id}-profit`}>
            Money left after business expenses
          </label>
          <SignedCurrencyInput
            id={`${id}-profit`}
            currency={currency}
            value={profit}
            onValueChange={setProfit}
          />
          <label htmlFor={`${id}-pay`}>
            Your salary (if counted in expenses)
          </label>
          <SignedCurrencyInput
            id={`${id}-pay`}
            currency={currency}
            value={pay}
            onValueChange={setPay}
          />
          <p className="text-sm text-muted-foreground">
            Enter 0 if your salary wasn’t counted in expenses. Don’t add money
            you took from the remaining profit.
          </p>
          <Button
            type="button"
            variant="outline"
            disabled={
              disabled ||
              !profit ||
              !pay ||
              !Number.isFinite(Number(profit)) ||
              !Number.isFinite(Number(pay))
            }
            onClick={() =>
              onChange(
                String(Math.round((Number(profit) + Number(pay)) * 100) / 100),
              )
            }
          >
            Use this total
          </Button>
        </div>
      </details>
    </div>
  );
}
